import Chip from '@components/v2/ui/Chip/Chip';
import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { X } from 'lucide-react';
import { ChipListItem } from './chipList.types';
import { useIsTextTruncated } from './hooks/useIsTextTruncated';

interface Props {
  item: ChipListItem;
  isShrinkable?: boolean;
}

const ChipItem = ({ item, isShrinkable }: Props) => {
  const { setElement, isTruncated } = useIsTextTruncated<HTMLSpanElement>();

  return (
    <Tooltip
      TooltipContent={item.tooltip ?? (isTruncated ? item.label : undefined)}
      tabIndex={item.disabled || (!item.onClick && !item.onDelete) ? 0 : -1}
    >
      <Chip
        label={item.label}
        size="small"
        disabled={item.disabled}
        className={item.className}
        sx={isShrinkable ? { minWidth: 0, flexShrink: 1 } : undefined}
        slotProps={{ label: { ref: setElement } }}
        onClick={
          item.onClick &&
          ((event) => {
            event.stopPropagation();
            item.onClick?.(event);
          })
        }
        onDelete={item.onDelete}
        deleteIcon={
          item.onDelete && (
            <Icon icon={X} onMouseDown={(event) => event.stopPropagation()} size="sm" />
          )
        }
      />
    </Tooltip>
  );
};

export default ChipItem;
